import { render } from "./HistoricoDocumento.vue?vue&type=template&id=585d0073"
import script from "./HistoricoDocumento.vue?vue&type=script&lang=js"
export * from "./HistoricoDocumento.vue?vue&type=script&lang=js"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__